import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=403b6b08&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=403b6b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403b6b08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('403b6b08')) {
      api.createRecord('403b6b08', component.options)
    } else {
      api.reload('403b6b08', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=403b6b08&scoped=true&", function () {
      api.rerender('403b6b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layouts/HeaderBar/Navigation.vue"
export default component.exports